export default class InvalidRouteTimeException extends Error {
  constructor(message, identifier) {
    super(message);
    this.identifier = identifier;
  }
}
